import React, { Component } from "react";
import { connect } from "react-redux";
import * as dataActions from "../../../../_actions/dataActions";
import * as searchActions from "../../../../_actions/searchActions";
import FilterWidget from "../../../UI/FilterWidget";
import Slider from "../../../UI/Slider";
import Select from "../../../UI/Select";
import Wrapper from "../../../../_hoc/Wrapper";
import PageSubTitle from "../../../UI/PageSubTitle";
import getMaritalStatus from "../../../../_selectors/dataSelectors/getMaritalStatus";
import getMotherTongue from "../../../../_selectors/dataSelectors/getMotherTongue";
import getReligion from "../../../../_selectors/dataSelectors/getReligion";
import getMyGender from "../../../../_selectors/userSelectors/getMyGender";
class Filter extends Component {
  state = {
    showFilter: true,
    ageStart: 24,
    ageEnd: 27,
    selectedMaritalStatus: [],
    selectedMotherTongue: [],
    selectedReligion: []
  };
  componentDidMount() {
    const {
      maritalStatus,
      getMaritalStatusData,
      motherTongue,
      getMotherTongueData,
      religion,
      getReligionData
    } = this.props;

    if (maritalStatus.length === 0) {
      getMaritalStatusData();
    }
    if (motherTongue.length === 0) {
      getMotherTongueData();
    }
    if (religion.length === 0) {
      getReligionData();
    }
  }
  toggleShowFilter = () => {
    this.setState(prevState => ({ showFilter: !prevState.showFilter }));
  };
  search = () => {
    const {
      ageEnd,
      ageStart,
      selectedMaritalStatus,
      selectedMotherTongue,
      selectedReligion
    } = this.state;
    const { search, isFemale } = this.props;
    search({
      data: {
        ageEnd,
        ageStart,
        maritalStatus: selectedMaritalStatus,
        motherTongue: selectedMotherTongue,
        religion: selectedReligion,
        isFemale
      }
    });
  };
  render() {
    const {
      showFilter,
      selectedMaritalStatus,
      selectedMotherTongue,
      selectedReligion,
      ageEnd,
      ageStart
    } = this.state;
    const { maritalStatus, motherTongue, religion } = this.props;
    return (
      <div className="row">
        <div className="col-md-6 col-md-offset-3">
          <PageSubTitle center>
            <h3>Search in FAQ</h3>
            <p>
              Add quick, dynamic tab functionality to transition through panes
              of local content.
            </p>
          </PageSubTitle>
          <form>
            <div class="form-group">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  id="dev-faq-keyword"
                  placeholder="Search..."
                />
                <div class="input-group-btn">
                  <button class="btn btn-default" id="dev-faq-search">
                    <i class="fa fa-search" />
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  maritalStatus: getMaritalStatus(state),
  motherTongue: getMotherTongue(state),
  religion: getReligion(state),
  isFemale: getMyGender(state)
});
const mapDispatchToProps = dispatch => ({
  getMaritalStatusData: () => dispatch(dataActions.getMaritalStatus()),
  getMotherTongueData: () => dispatch(dataActions.getMotherTongue()),
  getReligionData: () => dispatch(dataActions.getReligion()),
  search: payload => dispatch(searchActions.search(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Filter);



// WEBPACK FOOTER //
// ./src/_components/Search/Name/Filter/index.js